<template>
  <div>
    <!-- DATE -->
    <div class="input-group">
      <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
      <input type="text" ref="dateFieldInput" :id="pFieldValueInputId" :name="fieldValueInputName"
             size="12" maxlength="10" v-model="value" class="form-control"/>
    </div>
    <!-- DATE FORMAT HINT -->
    <p v-if="dateFormatHintVisible" class="help-block">
      <label>{{ 'dictionary.general.hint.format' | i18nText(pDictionary) }}:</label>
      {{ dateFormatHintTextI18n }}
    </p>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import stringHelpers from "@/helpers/string-helpers";

export default {
  name: "FieldValueDateForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFieldValue: {
      type: Object,
      required: true
    },
    pFieldValueInputId: {
      type: String,
      required: true
    },
    pFieldValueInputNamePrefix: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      value: this.pFieldValue.value
    }
  },
  computed: {
    fieldValueInputName: function () {
      return this.pFieldValueInputNamePrefix + ".value";
    },
    fieldValueInputReadonly: function () {
      return this.pFieldValue.generated;
    },
    dateFormatHintVisible: function () {
      return !stringHelpers.isEmptyOrNull(this.dateFormatHintTextI18n);
    },
    dateFormatHintTextI18n: function () {
      if(this.pLanguage === 'fr' && !stringHelpers.isEmptyOrNull(this.pFieldValue.dateFormatHints.fr))
      {
        return this.pFieldValue.dateFormatHints.fr;
      }
      return this.pFieldValue.dateFormatHint;
    }
  },
  mounted: function () {
    let _component = this;

    let localeDateFormatHint = _component.pDictionary['dictionary.picker.date.CALENDAR_DATE_FORMAT.hint'];
    if(!stringHelpers.isEmptyOrNull(localeDateFormatHint)
       && !stringHelpers.isEmptyOrNull(_component.dateFormatHintTextI18n)
       && localeDateFormatHint === _component.dateFormatHintTextI18n) {
      // Init DateFieldInput Picker.
      let $dateFieldInput = $(this.$refs.dateFieldInput);
      $dateFieldInput.initFromDatePicker(
          {
            dateElId: $dateFieldInput.attr('id'),
            linkDateElId: null,
            minDate: null,
            maxDate: null,
            bs3: true,
            f: function (selectedDate) {
              _component.$data.value = selectedDate;
              _component.$refs.dateFieldInput.dispatchEvent(new Event('change'));
            }, noWeekends: false
          });
    }
  }
}
</script>

<style scoped>

</style>